<script setup lang="ts">
  defineProps<{
    title: string,
    resultCount: number,
  }>()
</script>

<template>
  <div>
    <div class="my-2 px-4 text-primary font-medium">
      {{ title }}
    </div>
    <div
      v-if="resultCount === 0"
      class="search-empty !py-2">
      Pencarian tidak ditemukan
    </div>
    <slot v-else></slot>
  </div>
</template>
